const routes = [
  {
    path: ["/", "/home"],
    exact: true,
    component: "Home",
  },
  { path: "/support", exact: true, component: "Support" },
  { path: "/about", exact: true, component: "About" },
  { path: "/contact", exact: true, component: "Contact" },
  { path: "/feedback", exact: true, component: "Feedback" },
];

export default routes;